import type { ProgressNoteData } from "@/modules/patients/detail/progress-note/types/progress-note-fragment-type"

export const hasDeBetterDocRecommendedCareProviders = (progressNoteData: ProgressNoteData): boolean =>
  progressNoteData.__typename === "de_ProgressNote" &&
  progressNoteData.betterDocResult?.kind === "CARE_PROVIDERS_RECOMMENDED"
